import React from "react";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { Eyebrow, Button } from "@/components/kit";

const faqs = [
  {
    q: "Wanneer zie ik écht resultaat?",
    a: "Eerste leads of kliks meestal binnen 7-14 dagen na live-gang van advertenties. SEO-rankings: 2-3 maanden. Sterke groei: vanaf 6 maanden. Wij delen elke maand transparant wat werkt én wat niet.",
  },
  {
    q: "Wat kost samenwerken met UPPIT?",
    a: "Pakketten starten vanaf €500 per maand voor lokale MKB tot €5.000+ voor e-commerce en B2B. Geen langlopende contracten — maandelijks opzegbaar. Na de gratis AI Growth Scan sturen we een voorstel op maat.",
  },
  {
    q: "Waarin verschillen jullie van andere marketingbureaus?",
    a: "Geen accountmanagers tussen jou en de strateeg — je hebt direct contact met de oprichter. Geen langlopende contracten. Geen vage rapportages: wij delen ROAS, CAC en LTV maandelijks. En AI-versnelling waardoor we méér doen voor minder budget.",
  },
  {
    q: "Word ik ook gevonden in ChatGPT en andere AI-platformen?",
    a: "Ja. Met onze AI-optimalisatie (GEO) zorgen we dat AI-modellen zoals ChatGPT, Perplexity en Gemini jouw merk noemen. Steeds meer klanten zoeken via AI in plaats van Google — daar wil je zichtbaar zijn.",
  },
  {
    q: "Werken jullie ook als ik nog geen website heb?",
    a: "Zeker. Wij bouwen je hele online fundament — website (Webflow of WordPress), copy, SEO en funnels — en zetten daarna de campagnes op. Van scratch naar leads binnen 8 weken.",
  },
  {
    q: "Wat als het niet werkt?",
    a: "Geen langlopende contracten, je zit nergens aan vast. In de praktijk slaagt 9 van de 10 trajecten — omdat we vóór de start eerlijk aangeven of we impact kunnen maken. Zo niet, dan hoor je dat direct in het intakegesprek.",
  },
];

const HomeFAQ = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section
      data-testid="home-faq-section"
      className="relative bg-ivory-200 py-24 lg:py-32"
    >
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-8 lg:gap-16 items-start">
          <div className="col-span-12 lg:col-span-4 lg:sticky lg:top-28">
            <Eyebrow>FAQ · Eerlijke antwoorden</Eyebrow>
            <h2 className="mt-6 font-display font-black text-coal tracking-tight leading-[0.95] text-4xl sm:text-5xl">
              Vragen die je nu <span className="text-gradient-blue">stelt.</span>
            </h2>
            <p className="mt-5 text-coal/60 leading-relaxed max-w-sm">
              Helder, zonder marketing-poëzie. Staat je vraag er niet bij? Stel hem direct.
            </p>
            <Button to="/contact" variant="outline" withArrow testid="faq-cta-contact" className="mt-7">
              Stel je vraag
            </Button>
          </div>

          <div className="col-span-12 lg:col-span-8">
            <div className="rounded-[1.5rem] border border-ivory-400 bg-white overflow-hidden shadow-card-light">
              {faqs.map((f, i) => (
                <details
                  key={i}
                  data-testid={`home-faq-item-${i}`}
                  className="group border-b border-ivory-300 last:border-b-0"
                >
                  <summary className="cursor-pointer flex items-start justify-between gap-6 list-none px-6 lg:px-8 py-6">
                    <div className="flex items-baseline gap-5">
                      <span className="font-mono text-[11px] text-electric shrink-0 pt-1">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display font-bold text-lg lg:text-xl text-coal leading-snug">
                        {f.q}
                      </span>
                    </div>
                    <Plus className="w-5 h-5 text-electric transition-transform duration-500 group-open:rotate-45 shrink-0 mt-1" />
                  </summary>
                  <div className="px-6 lg:px-8 pb-6 pl-[3.75rem] lg:pl-[4.5rem] -mt-1 text-coal/65 leading-relaxed max-w-2xl">
                    {f.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
